import { render } from "./ProviderConsentDialogV1.vue?vue&type=template&id=7f7c1a46&scoped=true"
import script from "./ProviderConsentDialogV1.vue?vue&type=script&lang=js"
export * from "./ProviderConsentDialogV1.vue?vue&type=script&lang=js"

import "./ProviderConsentDialogV1.vue?vue&type=style&index=0&id=7f7c1a46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7c1a46"]])

export default __exports__